import { useState } from "react";
import axios from "axios";

const UpdateForm = () => {
  const [table, setTable] = useState("");
  const [field, setField] = useState("");
  const [value, setValue] = useState("");
  const [limit, setLimit] = useState(100);
  const [conditions, setConditions] = useState([{ field: "", operator: "=", value: "" }]);
  const [saveQuery, setSaveQuery] = useState(false);
  const [purpose, setPurpose] = useState("");
  const [addedBy, setAddedBy] = useState("");

  // Add new condition
  const handleAddCondition = () => {
    setConditions([...conditions, { field: "", operator: "=", value: "" }]);
  };

  // Remove a condition
  const handleRemoveCondition = (index) => {
    setConditions(conditions.filter((_, i) => i !== index));
  };

  // Update condition field/operator/value
  const handleConditionChange = (index, key, value) => {
    const newConditions = [...conditions];
    newConditions[index][key] = value;
    setConditions(newConditions);
  };

  // Submit handler
  const handleSubmit = async (e, isSave) => {
    e.preventDefault();
    const requestData = { 
      table, 
      field, 
      value, 
      conditions, 
      limit, 
      save: isSave ? 1 : 0 // If "Save Query" is clicked, set save = 1
    };

    // Add purpose & added_by if saving query
    if (isSave) {
      requestData.purpose = purpose;
      requestData.added_by = addedBy;
    }

    try {
      const response = await axios.post("https://rules.infomanav.in/api/v1/update-data", requestData);
      alert(response.data.message);
      console.log(response.data);
    } catch (error) {
      console.error("Error updating data:", error);
      alert("Update failed!");
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-gray-100 rounded-lg shadow-lg">
      <h2 className="text-xl font-bold mb-4">Update Table Data</h2>
      <form className="space-y-4">

        {/* Table Name */}
        <div>
          <label className="block font-medium">Table Name:</label>
          <input
            type="text"
            value={table}
            onChange={(e) => setTable(e.target.value)}
            className="w-full p-2 border rounded-lg"
            placeholder="Enter table name"
            required
          />
        </div>

        {/* Field to Update */}
        <div>
          <label className="block font-medium">Field to Update:</label>
          <input
            type="text"
            value={field}
            onChange={(e) => setField(e.target.value)}
            className="w-full p-2 border rounded-lg"
            placeholder="Enter field name"
            required
          />
        </div>

        {/* Value to Set */}
        <div>
          <label className="block font-medium">New Value:</label>
          <input
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="w-full p-2 border rounded-lg"
            placeholder="Enter new value"
            required
          />
        </div>

        {/* Conditions Section */}
        <h3 className="text-lg font-semibold">Conditions:</h3>
        <div className="space-y-3">
          {conditions.map((condition, index) => (
            <div key={index} className="flex space-x-2 items-center">
              <input
                type="text"
                placeholder="Field"
                value={condition.field}
                onChange={(e) => handleConditionChange(index, "field", e.target.value)}
                className="p-2 border rounded-lg"
                required
              />
              
              <select
                value={condition.operator}
                onChange={(e) => handleConditionChange(index, "operator", e.target.value)}
                className="p-2 border rounded-lg"
              >
                <option value="=">=</option>
                <option value="!=">!=</option>
                <option value=">">{">"}</option>
                <option value="<">{"<"}</option>
                <option value="LIKE">LIKE</option>
                <option value="IN">IN</option>
                <option value="NOT IN">NOT IN</option>
                <option value="OR">OR</option>
              </select>

              <input
                type="text"
                placeholder="Value"
                value={condition.value}
                onChange={(e) => handleConditionChange(index, "value", e.target.value)}
                className="p-2 border rounded-lg"
                required
              />

              <button
                type="button"
                className="bg-red-500 text-white px-3 py-2 rounded-lg hover:bg-red-600"
                onClick={() => handleRemoveCondition(index)}
              >
                Remove
              </button>
            </div>
          ))}
        </div>

        {/* Add Condition Button */}
        <button
          type="button"
          className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
          onClick={handleAddCondition}
        >
          + Add Condition
        </button>

        {/* Limit Input */}
        <div>
          <label className="block font-medium">Limit:</label>
          <input
            type="number"
            value={limit}
            onChange={(e) => setLimit(e.target.value)}
            className="w-full p-2 border rounded-lg"
            min="1"
            required
          />
        </div>

        {/* Save Query Checkbox */}
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={saveQuery}
            onChange={() => setSaveQuery(!saveQuery)}
          />
          <label>Save Query</label>
        </div>

        {/* Additional Fields for Save Query */}
        {saveQuery && (
          <>
            <div>
              <label className="block font-medium">Purpose:</label>
              <input
                type="text"
                value={purpose}
                onChange={(e) => setPurpose(e.target.value)}
                className="w-full p-2 border rounded-lg"
                placeholder="Enter purpose"
              />
            </div>
            <div>
              <label className="block font-medium">Added By:</label>
              <input
                type="text"
                value={addedBy}
                onChange={(e) => setAddedBy(e.target.value)}
                className="w-full p-2 border rounded-lg"
                placeholder="Enter name"
              />
            </div>
          </>
        )}

        {/* Submit Buttons */}
        <div className="flex space-x-4">
          <button
            type="button"
            className="w-full bg-green-500 text-white py-2 rounded-lg hover:bg-green-600"
            onClick={(e) => handleSubmit(e, false)}
          >
            Run Query
          </button>
          <button
            type="button"
            className="w-full bg-orange-500 text-white py-2 rounded-lg hover:bg-orange-600"
            onClick={(e) => handleSubmit(e, true)}
          >
            Save to DB
          </button>
        </div>

      </form>
    </div>
  );
};

export default UpdateForm;
